import { createI18n } from 'vue-i18n';
import common from './messages/common';
import dashboard from './messages/dashboard';
import login from './messages/login';
import management from './messages/management';
import detail from './messages/detail';

export const supportedLocales = ['nl', 'en', 'fr', 'de'];
export const localeStorageKey = 'vlecad-insights-locale';

export function normalizeLocale(value) {
  const locale = String(value || '').trim().toLowerCase().split(/[-_]/)[0];
  return supportedLocales.includes(locale) ? locale : null;
}

function getStoredLocale() {
  try {
    return normalizeLocale(window.localStorage.getItem(localeStorageKey));
  } catch (error) {
    return null;
  }
}

export const initialLocale = getStoredLocale() || 'nl';

function getNamespace(catalog, locale, namespace) {
  const localizedMessages = catalog[locale] || {};
  return localizedMessages[namespace] || localizedMessages;
}

export const messages = Object.fromEntries(
  supportedLocales.map((locale) => [
    locale,
    {
      common: common[locale],
      dashboard: getNamespace(dashboard, locale, 'dashboard'),
      login: getNamespace(login, locale, 'login'),
      management: getNamespace(management, locale, 'management'),
      detail: getNamespace(detail, locale, 'detail'),
    },
  ]),
);

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: 'nl',
  messages,
  missingWarn: process.env.NODE_ENV !== 'production',
  fallbackWarn: process.env.NODE_ENV !== 'production',
});

export function applyDocumentLocale(value) {
  if (typeof document === 'undefined') return;

  const locale = normalizeLocale(value) || 'nl';
  const meta = messages[locale].common.meta;
  document.documentElement.lang = locale;
  document.title = meta.title;

  const description = document.querySelector('meta[name="description"]');
  if (description) description.setAttribute('content', meta.description);
}

export function setLocale(value) {
  const locale = normalizeLocale(value) || 'nl';
  i18n.global.locale.value = locale;

  try {
    window.localStorage.setItem(localeStorageKey, locale);
  } catch (error) {
    // The selected language still works when storage is disabled.
  }

  applyDocumentLocale(locale);
}

applyDocumentLocale(initialLocale);

export default i18n;
